module.exports = __webpack_public_path__ + "img/menuTag.a6a873bc.jpg";